var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { withStyles, makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import Select from '@mui/material/Select';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import Input from '@mui/material/Input';
import { ReactComponent as CalenderIcon } from 'assets/icons/Calender.svg';
import { ReactComponent as Time } from 'assets/icons/Time.svg';
import moment from 'moment';
import clsx from 'clsx';
var OpenPickerIcon = function () {
    return _jsx(CalenderIcon, { "aria-label": 'right-align', height: 20 });
};
var OpenTimePickerIcon = function () {
    return _jsx(Time, { "aria-label": 'right-align', height: 20 });
};
var inputDatePickerStyles = makeStyles()(function (theme) { return ({
    root: {
        '&.MuiTextField-root': {
            backgroundColor: theme.palette.common.white,
            width: '100%',
            borderRadius: 5,
            paddingTop: 5,
            paddingLeft: 10,
            paddingRight: 10,
            margin: 0,
            height: 39,
            borderWidth: 0,
            border: "1px solid ".concat(theme.palette.customColor.borderGrey),
            '& .MuiInput-underline:before': {
                borderBottom: "0px solid ".concat(theme.palette.common.white),
            },
            '& .MuiInput-underline:after': {
                borderBottom: "0px solid ".concat(theme.palette.common.white),
            },
        },
    },
    error: {
        '& .MuiFormHelperText-root.Mui-error': {
            color: theme.palette.customColor.error,
            fontSize: 13,
            position: 'relative',
            right: 9,
        },
    },
    timePickerIconColor: {
        '& svg': {
            '& path': {
                fill: theme.palette.customColor.primaryGreen,
            },
        },
    },
}); });
var InputText = withStyles(function (props) { return _jsx(TextField, __assign({}, props)); }, function () { return ({
    root: {
        backgroundColor: '#EAF8F7',
        borderRadius: 7,
        '& .MuiOutlinedInput-root': {
            height: 40,
        },
        '& .MuiInputBase-multiline': {
            height: 'auto',
        },
    },
}); });
var InputMasked = withStyles(function (props) {
    return _jsx(Input, __assign({}, props));
}, function () { return ({
    root: {
        backgroundColor: '#EAF8F7',
        borderRadius: 4,
        padding: '18.5px 14px',
        height: 40,
        '& .MuiOutlinedInput-root': {
            height: 40,
        },
        '& .MuiOutlinedInput-multiline': {
            height: 'auto',
        },
        '&.MuiInput-underline::before': {
            borderBottom: '0px solid #fff',
        },
        '&.MuiInput-underline::after': {
            borderBottom: '0px solid #fff',
        },
        '&:hover': {
            '&.MuiInput-underline::before': {
                borderBottom: '0px solid #fff',
            },
            '&.MuiInput-underline::after': {
                borderBottom: '0px solid #fff',
            },
        },
    },
}); });
var InputDatePicker = function (props) {
    var classes = inputDatePickerStyles().classes;
    return (_jsx(DatePicker, __assign({}, props, { components: {
            OpenPickerIcon: OpenPickerIcon,
        }, renderInput: function (params) { return (_jsx(TextField, __assign({ variant: 'standard' }, params, { sx: {
                svg: {
                    '& .cls-1': {
                        fill: props.disabled ? '#a7a7a7' : '#0186a5 ',
                    },
                },
            } }))); }, className: clsx(classes.root, classes.error, classes.timePickerIconColor, props.className), value: props.value })));
};
var InputControlledDatePicker = function (props) {
    var classes = inputDatePickerStyles().classes;
    var error = props.error;
    var onKeyDown = function (e) {
        e.preventDefault();
    };
    return (_jsx(DatePicker, __assign({}, props, { components: {
            OpenPickerIcon: OpenPickerIcon,
        }, renderInput: function (params) {
            return (_jsx(TextField, __assign({ variant: 'standard', helperText: props.helperText }, params, { error: error === 'Required Field' || params.error, sx: {
                    svg: {
                        '& .cls-1': {
                            fill: props.disabled ? '#a7a7a7' : '#6ba539',
                        },
                    },
                }, onKeyDown: onKeyDown })));
        }, className: clsx(classes.root, classes.error, props.className), value: props.value, "data-error": props.isError ? 'error' : '' })));
};
var InputTimePicker = function (props) {
    var classes = inputDatePickerStyles().classes;
    var _a = React.useState(null), customTime = _a[0], setCustomTime = _a[1];
    useEffect(function () {
        setCustomTime(props.value);
    }, [props.value]);
    return (_jsx(TimePicker, __assign({}, props, { components: {
            OpenPickerIcon: OpenTimePickerIcon,
        }, onOpen: function () {
            if (!props.value) {
                setCustomTime(moment().format());
            }
            if (props.onOpen) {
                props.onOpen();
            }
        }, onClose: function () {
            if (!props.value) {
                setCustomTime(null);
            }
            if (props.onClose) {
                props.onClose();
            }
        }, renderInput: function (params) { return _jsx(TextField, __assign({ variant: 'standard' }, params)); }, className: clsx(classes.root, classes.error, classes.timePickerIconColor, props.className), showToolbar: true, value: customTime })));
};
var StyledInputRadio = withStyles(Radio, function (_theme, _params, classes) {
    var _a;
    return ({
        root: (_a = {
                color: '#000',
                height: 25,
                width: 35
            },
            _a["&.".concat(classes.checked)] = {
                color: '#32602F',
            },
            _a),
        checked: {},
    });
});
var InputRadio = function (props) { return (_jsx(StyledInputRadio, __assign({ color: 'default' }, props))); };
var StyledInputCheckbox = withStyles(Checkbox, function (_theme, _params, classes) {
    var _a;
    return ({
        root: (_a = {
                color: '#000',
                height: 25,
                width: 35,
                '&:hover': {
                    background: 'transparent',
                }
            },
            _a["&.".concat(classes.checked)] = {
                color: '#32602F',
            },
            _a['& svg'] = {
                width: '1.2em',
                height: '1.2em',
            },
            _a['&.Mui-disabled'] = {
                color: '#ccc',
            },
            _a),
        checked: {},
    });
});
var InputCheckBox = function (props) { return (_jsx(StyledInputCheckbox, __assign({ icon: _jsx(CheckBoxOutlineBlankSharpIcon, { fontSize: 'medium' }), checkedIcon: _jsx(CheckBoxSharpIcon, {}), "data-testid": "".concat(props.value), color: 'default' }, props))); };
var Label = withStyles(function (props) { return _jsx(InputLabel, __assign({}, props)); }, function (theme) { return ({
    root: {
        color: '#000',
        marginBottom: theme.spacing(1),
        whiteSpace: 'pre-wrap',
    },
}); });
var InputSelect = withStyles(function (props) { return (_jsx(FormControl, { style: { marginTop: 0 }, margin: 'dense', fullWidth: true, children: _jsx(Select, __assign({ id: props.id, SelectDisplayProps: { style: { backgroundColor: '#EAF8F7', padding: 9 } }, displayEmpty: true, MenuProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            getContentAnchorEl: null,
        } }, props)) })); }, function () { return ({
    root: {
        backgroundColor: '#EAF8F7',
        borderRadius: 7,
    },
    outlined: {
        borderColor: '#EAF8F7',
    },
}); });
export { InputText, Label, InputSelect, InputDatePicker, InputTimePicker, InputCheckBox, InputRadio, InputControlledDatePicker, InputMasked, };
